<template>
  <v-app id="app" class="auth-layout">
    <v-content>
      <myHeader />

      <v-container fluid fill-height>
        <router-view />
      </v-container>
    </v-content>

    <!-- <span class="version">{{ $getAppVersion() }}</span> -->
    <notificationBar />
  </v-app>
</template>

<script>
import myHeader from "../../themes/partials/HeaderAuth.vue"
import notificationBar from "@/modules/notifications/partials/NotificationBar.vue"

export default {
  name: "my-login-layout",

  components: {
    myHeader,
    notificationBar
  }
}
</script>
